import { render, staticRenderFns } from "./productDetail.vue?vue&type=template&id=48114c6e&scoped=true&"
import script from "./productDetail.vue?vue&type=script&lang=js&"
export * from "./productDetail.vue?vue&type=script&lang=js&"
import style0 from "./productDetail.vue?vue&type=style&index=0&id=48114c6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48114c6e",
  null
  
)

export default component.exports